<template>
    <v-date-picker :min-date="data.minDate"
                   :max-date="data.maxDate"
                   :color="data.dateColor"
                   :model-value="value"
                   @update:model-value="input"
                   :mode="dateMode"
                   :is24hr="timeFormat==24"
                   :is-dark="$store.state.theme.darkMode"
                   :masks="{
                       modelValue: modelValueMask,
                       input:[dateFormat],
                       inputDateTime:[dateFormat+' h:mm A'],
                       inputDateTime24hr:[dateFormat+' HH:mm'],
                       inputTime:['h:mm A'],
                       inputTime24hr:['HH:mm']
                   }"
                   :is-range="isRange"
                   :popover="{visibility: 'click', placement: data.popoverPosition}">
        <template #default="{ inputValue, inputEvents }">
            <div class="date-picker-input" :class="{'date-picker-input-group':borderGroup}">
                <div class="input-group"
                     :class="{'disabled':data.disabled}"
                     @focusin="borderGroup=true"
                     @focusout="borderGroup=false">
                    <template v-if="isRange">
                        <input :value="inputValue.start || inputValue.end ? inputValue.start+' - '+inputValue.end: ''"
                               :placeholder="data.placeholder"
                               readonly
                               v-on="inputEvents.start || inputEvents.end"
                               class="form-control"/>
                    </template>
                    <template v-else>
                        <input :value="inputValue ? inputValue : ''"
                               :placeholder="data.placeholder"
                               v-on="inputEvents"
                               class="form-control"/>
                    </template>
                    <div class="input-group-append">
                        <span class="input-group-text">
                            <app-icon :name="'calendar'"/>
                        </span>
                    </div>
                </div>
            </div>
        </template>
    </v-date-picker>
</template>

<script>
import {InputMixin} from './mixin/InputMixin.js';
import CoreLibrary from "../../helpers/CoreLibrary";
import moment from 'moment';

export default {
    emits: ['input'],
    name: "DatePicker",
    extends: CoreLibrary,

    mixins: [InputMixin],

    data() {
        return {
            borderGroup: false,
        }
    },
    computed: {
        isRange() {
            if (this.data.dateMode === 'range') {
                return true
            }
            return this.isUndefined(this.data.isRange) ? false : this.data.isRange;
        },
        dateMode() {
            if (this.data.dateMode === 'range' || this.isUndefined(this.data.dateMode)) {
                return 'date';
            } else return this.data.dateMode;
        },
        // v-calendar 3 removed `model-config`; the model type is controlled via
        // the `modelValue` mask instead. We keep the old string contract so the
        // rest of the app still receives 'YYYY-MM-DD HH:mm:ss' strings.
        modelValueMask() {
            return 'YYYY-MM-DD HH:mm:ss';
        }
    },
    methods: {
        toStr(date) {
            if (!date) return date;
            return moment(date).format('YYYY-MM-DD HH:mm:ss');
        },
        input(date) {
            let out;
            if (date && typeof date === 'object' && ('start' in date || 'end' in date)) {
                out = { start: this.toStr(date.start), end: this.toStr(date.end) };
            } else {
                out = this.toStr(date);
            }
            this.fieldValue = out;
            this.$emit('input', out);
        }
    }
}
</script>
